// enable debug mode by running localStorage.setItem('pulse_debug_mode', 'true');
// this is useful for development and debugging on all environments
// recommend removing logs once the feature is stable
// note: refresh the page after setting the value to enable debug mode
const isDebugMode = localStorage.getItem('pulse_debug_mode') === 'true';

export const logger = {
  log: (...args: any[]) => {
    if (isDebugMode) {
      console.log('[LOG]', ...args);
    }
  },
  error: (...args: any[]) => {
    if (isDebugMode) {
      console.error('[ERROR]', ...args);
    }
  },
};
